import { Cancel, CheckCircle, Info, Warning } from '@material-ui/icons';
import { AlertProps as $AlertProps } from 'antd/lib/alert';
import React, { FC, useCallback } from 'react';

import { AlertCloseClickCallback } from '.';

import { Alert as $Alert } from '../components/common/antd/antd-override';

export type AlertProps = Omit<$AlertProps, 'onClose'> & { onClose?: AlertCloseClickCallback };

const Alert: FC<AlertProps> = ({ type = 'error', showIcon = true, closable = true, onClose, ...rest }) => {
  const onCloseAlert = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      onClose && onClose({ alertType: type });
    },
    [onClose, type]
  );

  const getIcon = (type?: string) => {
    switch (type) {
      case 'error':
        return <Cancel />;
      case 'warning':
        return <Warning />;
      case 'info':
        return <Info />;
      case 'success':
      default:
        return <CheckCircle />;
    }
  };

  return (
    <$Alert
      showIcon={showIcon}
      closable={closable}
      type={type}
      onClose={onCloseAlert}
      icon={getIcon(type)}
      {...rest}
    ></$Alert>
  );
};

export default Alert;
